<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_frame' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="cancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <!-- Configuration mode -->
    <div class="mode-card">
      <div class="mode-label">
        {{ 'configuration_mode' | translate }}
      </div>

      <ion-segment [value]="mode" (ionChange)="onModeChange($event)" mode="md">

        <ion-segment-button value="by-frame">
          <ion-label class="text-wrap">{{ 'by_frame' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="by-brand">
          <ion-label class="text-wrap">{{ 'by_brand' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="manual">
          <ion-label class="text-wrap">{{ 'manually' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <!-- BY BRAND -->
    <ng-container *ngIf="mode === 'by-brand'">
      <div class="select-group">
        <label class="select-label">{{ 'brand' | translate }}</label>
        <ion-select [(ngModel)]="selectedManufacturerId" (ionChange)="onManufacturerChange()" interface="popover"
          placeholder="{{ 'selectBrand' | translate }}" class="styled-select" cssClass="select-popover">
          <ion-select-option *ngFor="let m of manufacturers" [value]="m.id">
            {{ m.name }}
          </ion-select-option>
        </ion-select>
      </div>
      <div class="select-group" *ngIf="selectedManufacturerId">
        <label class="select-label">{{ 'system' | translate }}</label>
        <!-- <ion-select [(ngModel)]="selectedSystemId" (ionChange)="onSystemChange()" interface="popover"
          class="styled-select" [interfaceOptions]="{ cssClass: 'system-select-popover' }">
          <ion-select-option *ngFor="let sys of filteredSystems" [value]="sys.id">
            {{ sys.name }}{{ sys.variant ? '\n' + (sys.variant | translate) : '' }}
          </ion-select-option>
        </ion-select> -->
        <div class="styled-select custom-select-trigger" (click)="openSystemPopover($event)">
          <span class="selected-text" *ngIf="selectedSystem; else systemPlaceholder">
            {{ selectedSystem.name }}
            <span *ngIf="selectedSystem.variant">
              — {{ selectedSystem.variant | translate }}
            </span>
          </span>
          <ng-template #systemPlaceholder>
            <span class="placeholder"></span>
          </ng-template>
          <ion-icon name="chevron-down-outline"></ion-icon>
        </div>
      </div>
    </ng-container>

    <!-- BY Frame -->
    <ng-container *ngIf="mode === 'by-frame'">
      <div class="select-group">
        <label class="select-label">{{'FRAME_WIDTH_M' | translate}}</label>
        <ion-input class="bordered-input" type="number" [(ngModel)]="frameWidth" name="frameWidth" step="0.01" min="0">
        </ion-input>
      </div>
      <div class="select-group">
        <label class="select-label">{{ 'filter' | translate }}</label>
        <div class="filter-row">
          <ion-select [(ngModel)]="frameTypeFilter" (ionChange)="onFrameTypeFilterChange()" interface="popover"
            class="styled-select filter-select" cssClass="select-popover" placeholder="All">
            <ion-select-option [value]="null">{{ 'type' | translate }}</ion-select-option>
            <ion-select-option *ngFor="let type of availableFrameTypes" [value]="type.value">
              {{ type.label | translate }}
            </ion-select-option>
          </ion-select>

          <ion-select [(ngModel)]="frameUfFilter" (ionChange)="onFrameUfFilterChange()" interface="popover"
            class="styled-select filter-select" cssClass="select-popover" placeholder="All">
            <ion-select-option [value]="null">{{ 'uf_value' | translate }}</ion-select-option>
            <ion-select-option *ngFor="let uf of availableUfOptions" [value]="uf">
              {{ uf }}
            </ion-select-option>
          </ion-select>
        </div>
      </div>
      <ion-list>
        <ng-container *ngFor="let frame of filteredFrameList">
          <ion-item lines="none" class="cardDiv" (click)="selectFrame(frame)"
            [ngClass]="frame.id == selectedFrameId ? 'selected' : ''">
            <div class="image-container">
              <img [src]="frame.img" class="square-image" />
            </div>
            <div class="content-container">
              <h5 class="card-title">{{ frame.type | translate }}</h5>
              <p class="card-subtitle">{{ 'uf_value' | translate }}: {{ frame.uf }} W/m²K</p>
            </div>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-container>

    <!-- MANUAL -->
    <ng-container *ngIf="mode === 'manual'">
      <div class="form-container">
        <div class="select-group">
          <label class="select-label">{{'HEADER_NAME' | translate}}</label>
          <ion-input class="bordered-input" type="text" [(ngModel)]="manualFrame.name" name="manualFrameName">
          </ion-input>
        </div>

        <div class="select-group">
          <label class="select-label">{{ 'HEADER_TYPE' | translate }}</label>
          <ion-select [(ngModel)]="manualFrame.type" interface="popover" class="styled-select"
            cssClass="select-popover">
            <ion-select-option *ngFor="let type of frameTypes" [value]="type.value">
              {{ type.label | translate }}
            </ion-select-option>
          </ion-select>
        </div>

        <div class="section-divider"></div>
        <div *ngIf="applyIdenticalInput">
          <div class="select-group">
            <label class="select-label">{{'UF_UNIT' | translate}}</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="identicalUf"
              (ngModelChange)="onIdenticalUfChange()" step="0.1" min="0.1" max="5.0">
            </ion-input>
          </div>

          <div class="select-group">
            <label class="select-label">{{'FRAME_WIDTH_M' | translate}}</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="identicalWidth"
              (ngModelChange)="onIdenticalWidthChange()" step="0.01" min="0.01" max="1.0">
            </ion-input>
          </div>
        </div>
        <div *ngIf="!applyIdenticalInput">
          <div class="table-header">
            <div class="header-label"></div>
            <div class="header-value">Uf (W/m²K)</div>
            <div class="header-value">{{ 'pdf.width' | translate}} (m)</div>
          </div>

          <!-- Frame Parts List -->
          <div class="frame-parts-list">
            <div *ngFor="let index of getFrameRange()" class="frame-row">
              <!-- Image & Label -->
              <div class="frame-info">
                <img [src]="getFramePartImage(index)" class="frame-icon" alt="Frame part" />
                <div class="frame-text">
                  <div class="frame-label">{{ getFramePartLabel(index) }}</div>
                  <div class="frame-subtitle" *ngIf="getFramePartSubtitle(index)">
                    {{ getFramePartSubtitle(index) }}
                  </div>
                </div>
              </div>
              <!-- Uf Input -->
              <div class="input-wrapper">
                <ion-input class="value-input" type="number" [(ngModel)]="frameData[index].uf" step="0.1" min="0.1"
                  max="5.0">
                </ion-input>
              </div>

              <!-- Width Input -->
              <div class="input-wrapper">
                <ion-input class="value-input" type="number" [(ngModel)]="frameData[index].w" step="0.01" min="0.01"
                  max="1.0">
                </ion-input>
              </div>
            </div>
          </div>
        </div>
        <div class="section-divider"></div>
        <!-- Checkboxes -->
        <div class="options-section">
          <ion-item lines="none" class="checkbox-item">
            <ion-checkbox slot="start" [(ngModel)]="applyIdenticalInput" (ionChange)="onApplyIdenticalChange()">
            </ion-checkbox>
            <ion-label>{{ 'identical_all_sides'| translate}}</ion-label>
          </ion-item>

          <ion-item lines="none" class="checkbox-item">
            <ion-checkbox slot="start" [(ngModel)]="roundValuesEN" (ionChange)="onRoundValuesChange()">
            </ion-checkbox>
            <ion-label>{{ 'round_values_ENISO10077' | translate }}</ion-label>
          </ion-item>
        </div>

      </div>
    </ng-container>
  </div>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" expand="block" [disabled]="isNextButtonDisabled()">
      {{ (mode === 'by-brand' ? 'next' : 'validate') | translate }}
    </ion-button>
  </div>
</ion-footer>